import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_SIGNATURE_HEIGHT_PX,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewAddendumInfo } from "../note-preview-types";
import ReportSectionTab from "./ReportSectionTab";
import { ReportSignatureDetail } from "./ReportSignatureBlock";

export interface ReportAddendumBlockProps {
  addendum: NotePreviewAddendumInfo;
  label?: string;
}

/** A signed text block below the original signature (addendum, co-sign); the original note above it is unchanged. */
const ReportAddendumBlock = ({
  addendum,
  label = NOTE_PREVIEW_LABELS.addendum,
}: ReportAddendumBlockProps) => (
  <ReportSectionTab
    label={label}
    style={{
      marginTop: 28,
      fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
      color: NOTE_PREVIEW_TEXT_COLOR,
      breakInside: "avoid",
    }}
  >
    <div style={{ whiteSpace: "pre-wrap" }}>{addendum.text}</div>
    <div style={{ height: NOTE_PREVIEW_SIGNATURE_HEIGHT_PX, marginTop: 12 }}>
      {addendum.image && (
        <img
          src={addendum.image}
          alt={addendum.signerName}
          style={{ height: "100%", objectFit: "contain" }}
        />
      )}
    </div>
    <ReportSignatureDetail
      label={NOTE_PREVIEW_LABELS.name}
      value={addendum.signerName}
    />
    <ReportSignatureDetail
      label={NOTE_PREVIEW_LABELS.signedDateTime}
      value={addendum.signedAt}
    />
  </ReportSectionTab>
);

export default ReportAddendumBlock;
